import React, { FC, useMemo } from 'react';
import { Alert, Card, Tree } from 'antd';
import { DataNode } from 'rc-tree/lib/interface';
import { IngredientCategory } from '../../../../../model/ingredients';
import { Link, useRouteMatch } from 'react-router-dom';
import { ROUTER_PAGES } from '../../../../../routes';
import { useIngredientGroupRelationshipsMap } from './hooks';
import { useLocation } from 'react-router';
import { setQueryParams } from '../../../../../utils/url-search-params';

export interface SubGroupsTreeTreeProps {
    ingredientGroup: IngredientCategory;
}

const SubGroupsTree: FC<SubGroupsTreeTreeProps> = (props) => {
    const { ingredientGroup } = props;
    const [{ loading, error }, ingredientsMap] = useIngredientGroupRelationshipsMap();
    const match = useRouteMatch(ROUTER_PAGES.ingredientsGroups.path);
    const location = useLocation();
    const treeData: DataNode[] = useMemo(() => {
        const groupNode = ingredientsMap.get(ingredientGroup.id.toString());
        if (groupNode) {
            return groupNode.children.map((child): DataNode => {
                let to: string;
                if (match) {
                    // match, preserve page and other params
                    to = setQueryParams(location, {
                        selected: child.id.toString(),
                    });
                } else {
                    // not match, make just a link (to the first page)
                    to = `${ROUTER_PAGES.ingredientsGroups.path}?selected=${child.id}`;
                }
                return {
                    key: child.id,
                    title: <Link to={to}>{child.name}</Link>,
                };
            });
        } else {
            return [];
        }
    }, [ingredientGroup.id, ingredientsMap, location, match]);
    return (
        <Card loading={loading}>
            {error && <Alert message={'Can not load relationships'} description={error.message} type={'error'} />}
            {!error && treeData.length === 0 && <Alert message={'There is no sub-groups'} type={'info'} />}
            {!error && treeData.length > 0 && (
                <Tree treeData={treeData} selectable={false} showLine={{ showLeafIcon: false }} />
            )}
        </Card>
    );
};

export default SubGroupsTree;
